import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'recipes', component: () => import('../views/Recipes.vue') },
  { path: '/dish/edit', name: 'dishEdit', component: () => import('../views/DishEdit.vue') },
  { path: '/daily', name: 'daily', component: () => import('../views/DailyMenu.vue') },
  { path: '/shopping', name: 'shopping', component: () => import('../views/Shopping.vue') },
  { path: '/week', name: 'week', component: () => import('../views/WeekPlan.vue') },
  { path: '/diary', name: 'diary', component: () => import('../views/Diary.vue') }
]

export default new VueRouter({ routes })
